module.exports = __webpack_public_path__ + "static/media/chart-stock.0e7db07b.png";